import React from 'react';

// Box-and-whisker of same-cohort daily rate, with a brass marker for the
// user's watch. Matches the app team's approved mock. Domain is dynamic so it
// reads well for both mechanical (±10s) and quartz (±0.5s) watches.
// `box` = { p5, q1, median, q3, p95 } s/day; `you` = this watch's rate.
export default function ReportBoxWhisker({ box, you, height = 74, big = false }) {
  if (!box || box.median == null) return null;
  const p5 = Number(box.p5), q1 = Number(box.q1), med = Number(box.median),
        q3 = Number(box.q3), p95 = Number(box.p95), me = Number(you);
  const lo = Math.min(p5, me, 0), hi = Math.max(p95, me, 0);
  const span = Math.max(hi - lo, 0.5);
  const pad = span * 0.12;
  const dLo = lo - pad, dHi = hi + pad;
  const W = 320, H = height, mid = H / 2, bh = H * 0.42;
  const x = v => ((v - dLo) / (dHi - dLo)) * W;
  const r = big ? 6 : 4.5;
  return (
    <svg width="100%" height={H} viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="none"
      role="img" aria-label={`Your rate ${me > 0 ? '+' : ''}${me} s/day; cohort middle 50% from ${q1} to ${q3}, median ${med}`}>
      {/* zero line */}
      <line x1={x(0)} y1="0" x2={x(0)} y2={H} stroke="currentColor" strokeWidth="0.5" opacity="0.18" strokeDasharray="2 3" />
      {/* whiskers */}
      <line x1={x(p5)} y1={mid} x2={x(q1)} y2={mid} stroke="currentColor" strokeWidth="1" opacity="0.35" />
      <line x1={x(q3)} y1={mid} x2={x(p95)} y2={mid} stroke="currentColor" strokeWidth="1" opacity="0.35" />
      <line x1={x(p5)} y1={mid - bh / 2} x2={x(p5)} y2={mid + bh / 2} stroke="currentColor" strokeWidth="1" opacity="0.35" />
      <line x1={x(p95)} y1={mid - bh / 2} x2={x(p95)} y2={mid + bh / 2} stroke="currentColor" strokeWidth="1" opacity="0.35" />
      {/* IQR box */}
      <rect x={x(q1)} y={mid - bh} width={Math.max(x(q3) - x(q1), 1)} height={bh * 2} rx="3"
        fill="rgba(145,120,65,0.16)" stroke="rgba(145,120,65,0.55)" strokeWidth="1" />
      {/* median */}
      <line x1={x(med)} y1={mid - bh} x2={x(med)} y2={mid + bh} stroke="var(--rpt-brass, #917841)" strokeWidth="1.4" />
      {/* you */}
      <circle cx={x(me)} cy={mid} r={r} fill="var(--rpt-brass, #917841)" stroke="var(--rpt-card, #fff)" strokeWidth="1.6" />
    </svg>
  );
}
